import React from 'react'
import logo from "../../images/logo.png"

function About() {
  return (
    <div>

      <div className="p-5 smokeBackground">
          <h1 className="pt-3 display-5 fw-bold text-light">Carbono Zero</h1>
          <p className="pb-3 col-md-5 fs-2 text-light fw-light">Combatimos el cambio climático, plantamos árboles e incentivamos el reciclado.</p>
      </div>

      <div className='px-5 d-flex flex-column align-items-center'>

        <div>
          <h1 className="col-12 py-5 tittleText fw-bold">¿QUIÉNES SOMOS?</h1>
          <p className="grey fs-4">
            Somos un emprendimiento comenzado por un graduado de la Lic. en Ecología, Julio Barraza y un estudiante de dicha carrera,
            Christopher Acosta. Con el objetivo de brindar un proyecto ambiental que permita comenzar a evalular la huella de carbono y mititgar el Cambio Climático, mientras
            se reforesta y foresta con especies nativas, promoviendo el desarrollo sostenible desde todos los actores de la sociedad.
          </p>
        </div>

        <div>
          <h1 className="col-12 py-5 mt-5 tittleText fw-bold">¿QUÉ HACEMOS?</h1>
          <div className="mt-5">
            <h1 className="military2">Medir</h1>
            <p className="grey fs-4 ps-5">
              Nos especializamos en medir y evaluar la Huella de Carbono de las empresas e instituciones,
              De esta manera podemos conocer cuantas emisiones de Carbono, que son la principal causante del Cambio Climático
              emite cada negocio.
            </p>
          </div>
          <div className="mt-5">
            <h1 className="military2">Reducir</h1>
            <p className="grey fs-4 ps-5">
              Elaboramos reportes de emisiones, basados en estandares internacionales como el GHG y las normas ISO, que le permite
              a las empresas tener un respaldo de la contabilidad de sus emisiones, para acceder a bonos, mejorar su imagen, acceder a certificaciones,
              o enmarcarse en la Ley de Cambio Climático Nacional. El cual incluye un plan de reducciones de emisiones, con objetivos de reducción
              para los próximos años y recomendaciones.
            </p>
          </div>
          <div className="my-5 pb-2">
            <h1 className="military2">Compensar</h1>
            <p className="grey fs-4 ps-5">
              Aquellas emisiones que no puedan ser reducidas, serán compensadas plantando árboles nativos del monte santiagueño, los cuales pasarán a formar
              parte del Bosque Comunitario Virtual, un una importante herramienta para la responsabilidad social empresarial y asegurar el desarrollo sostenible
              en la provincia de Santiago, participando recicladores, empresas, ONGs, productores y otros ciudadanos.
            </p>
          </div>
        </div>

        <img src={logo} alt="logo" className='col-12 col-md-5 mb-5'/>

      </div>

    </div>
  )
}

export default About